// Capacitor initialization for mobile app
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { Keyboard } from '@capacitor/keyboard';

// Initialize Capacitor plugins for native functionality
export const initializeCapacitor = async () => {
  const isNative = Capacitor.isNativePlatform();
  
  if (!isNative) {
    // web browser mode
    return;
  }

  // native platform mode

  try {
    // Configure Status Bar
    await StatusBar.setStyle({ style: Style.Light });
    await StatusBar.setBackgroundColor({ color: '#0f766e' });
    
    // Hide splash screen after app is ready
    await SplashScreen.hide();

    // Handle keyboard events on iOS
    if (Capacitor.getPlatform() === 'ios') {
      Keyboard.addListener('keyboardWillShow', (info) => {
        document.body.style.paddingBottom = `${info.keyboardHeight}px`;
      });
      
      Keyboard.addListener('keyboardWillHide', () => {
        document.body.style.paddingBottom = '0px';
      });
    }

    // Handle app state changes
    App.addListener('appStateChange', ({ isActive }) => {
      // app state changed
    });

    // Handle back button on Android
    App.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) {
        window.history.back();
      } else {
        App.exitApp();
      }
    });

    // Handle deep links
    App.addListener('appUrlOpen', (event) => {
      // app URL handler
      // Handle deep link navigation here
      const slug = event.url.split('.app').pop();
      if (slug) {
        window.location.href = slug;
      }
    });

  } catch (error) {
    console.error('Capacitor initialization error:', error);
  }
};

// Check if running on native platform
export const isNativePlatform = () => Capacitor.isNativePlatform();

// Get current platform (ios, android, web)
export const getPlatform = () => Capacitor.getPlatform();

export default initializeCapacitor;
